import { PeerReviewStatus } from '../types/peerReview.type'
import { ReviewItemType } from '../types/reviewItemType.type'
import { Attribute } from './attributes.model'
import { FileMeta } from './file-meta.model'
import { ReviewItem } from './reviewItem.model'
import { FieldSafetyNoticeMetadata } from './reviewItemMetadata/fieldSafetyNoticeMetadata'
import { Search } from './search.model'

export class FieldSafetyNotice extends ReviewItem {
  metadata: FieldSafetyNoticeMetadata

  constructor({
    complaintDate,
    search,
    appraisal,
    fullTextScreening,
    suggestedFullTextScreening,
    id,
    isFavorite,
    maybeParentStudyId,
    oxfordLevelOfEvidence,
    parentStudyId,
    pdfFile,
    peerReviewStatus,
    synthesis,
    titleAndAbstractScreening,
    metadata,
  }: {
    id: number
    complaintDate?: Date
    search: Search
    appraisal?: { [key: string]: string }
    fullTextScreening?: string
    suggestedFullTextScreening?: string
    isFavorite?: boolean
    maybeParentStudyId?: number
    oxfordLevelOfEvidence?: string
    parentStudyId?: number
    pdfFile?: FileMeta
    peerReviewStatus?: PeerReviewStatus
    synthesis?: { attributes: Attribute[] }
    titleAndAbstractScreening?: string
    metadata?: FieldSafetyNoticeMetadata
  }) {
    super({
      complaintDate,
      search,
      appraisal,
      fullTextScreening,
      suggestedFullTextScreening,
      id,
      isFavorite,
      maybeParentStudyId,
      oxfordLevelOfEvidence,
      parentStudyId,
      pdfFile,
      peerReviewStatus,
      synthesis,
      titleAndAbstractScreening,
    })
    this.metadata = new FieldSafetyNoticeMetadata(metadata ?? {})
    this.type = ReviewItemType.FieldSafetyNotice
  }
}
